import {IColumnItem} from "@ui/tableCustom/types/columns";
import {Worksheet} from "exceljs";
import {GenerateExportExcelRowStylesCb} from "@ui/tableCustom/types/table";
import {buildStylesRowExcelJs} from "../styles/buildStyleRowExcelJs";

export const buildRowData = <T>({
                                    worksheet,
                                    data,
                                    columns,
                                    generateExportExcelRowStylesCb,
                                }: {
    columns: IColumnItem<T>[];
    data: unknown[],
    worksheet: Worksheet,
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
}) => {
    data.forEach(rowData => {
        const rowDataArray = columns.map(column => {
            if (column.hideExport) {
                return
            }
            if ('id' in column) {
                const contentKey = column['id'] as keyof unknown
                return rowData[contentKey]
            }
        });
        const rowExcelJs = worksheet.addRow(rowDataArray);

        buildStylesRowExcelJs<T>({
            columns,
            generateExportExcelRowStylesCb,
            rowExcelJs,
            content: rowData as T
        })
    });
}